module.exports = __webpack_public_path__ + "img/icon_verde_17.4034c49e.png";